///<amd-module name="typeahead/client/CarSearchResultsPageHandler" />

import {ClientHandlerRegistry, IClientHandler} from "typeahead/client/ClientHandlerRegistry";
import {GeolocationViewController} from "typeahead/core/geolocation/GeolocationViewController";

export class CarSearchResultsPageHandler implements IClientHandler {
    private static readonly rfrrIdPrefix: string = "CAR.SR|UpdateSearch";
    private static readonly APPLICABLE_CLIENT_ID = "Cars.Search";

    public isApplicable(clientId: string): boolean {
        return CarSearchResultsPageHandler.APPLICABLE_CLIENT_ID === clientId;
    }

    public subscribeFormSubmitEvent(): void {
        $("body").on("click", "a#wizard-toggle", () => {
            $("button#wizard-update").click(() => {
                ClientHandlerRegistry.publishSubmitClickedMessage(CarSearchResultsPageHandler.rfrrIdPrefix);
                // Since validation is done on server side
                ClientHandlerRegistry.publishFormSubmittedMessage(true);
            });
        });
    }

    public subscribeFormLoadedEvent(): void {
        // TODO
        /* Publish  a 'FormLoadedMessage' when any feature requires listening to form getting visible
        (when clicking Change Search) */
    }

    public getTab(): string {
        return undefined;
    }

    public getGeolocationViewController(): GeolocationViewController {
        return undefined;
    }
}
